<app-mat-spinner-overlay
  *ngIf="showWaitingForDataSpinner != 0"
  [overlay]="true"
>
</app-mat-spinner-overlay>

<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Hilfe</h4>
    </div>
  </div>
  <mat-card>
    <h5>Regionen</h5>
    <p>
      Die Anwendung „Betriebswirtschaftliche Ausrichtung“ zieht die für die
      EU-Statistik wichtigen
      <a class="cursor-hover" (click)="openInTabNutsZweiRegionen()"
        >NUTS-2 Regionen
        <fa-icon [icon]="faUpRightFromSquare" class="ml-1"></fa-icon
      ></a>
      heran. NUTS (französisch Nomenclature des unités territoriales
      statistiques) ist die hierarchische Systematik, mit der in der
      Europäischen Union räumliche Bezüge identifiziert und klassifiziert
      werden. Die „2“ steht für die zweite Gliederungsstufe, z.B.
      „Baden-Württemberg, Freiburg“.
    </p>

    <p>
      Zusätzlich bietet die Anwendung die Möglichkeit, auf Bundeslandebene oder
      für Deutschland gesamt zu klassifizieren.
    </p>
    <p>Die Region ist wie der Betriebsname eine Pflichteingabe.</p>

    <h5>Rechtliche Grundlagen</h5>
    <p>
      Maßgebend für nationale Klassifizierung ist die EU-Typologie nach
      Durchführungsverordnung (EU) 2019/1975 der Kommission vom 31. Oktober 2019
      zur Änderung der Durchführungsverordnung (EU) 2015/220 mit
      Durchführungsbestimmungen zur Verordnung (EG) Nr. 1217/2009 des Rates zur
      Bildung eines Informationsnetzes landwirtschaftlicher Buchführungen über
      die Einkommenslage und die betriebswirtschaftlichen Verhältnisse
      landwirtschaftlicher Betriebe in der Europäischen Union.
    </p>
    <p>
      Davon abweichende, spezifische Vereinbarungen auf nationaler Ebene sind
      möglich und werden in Deutschland im Einvernehmen zwischen den Mitgliedern
      des Arbeitskreises „Stuttgarter Programm“ sowie dem Bundesministerium für
      Ernährung und Landwirtschaft (BMEL), Referat 723 getroffen.
    </p>
    <h5>Dateneingabe, -ansicht und -ausgabe</h5>

    <p>
      Die Daten können manuell eingegeben oder via CSV-Datei hochgeladen werden.
    </p>
    <p>
      Manuell kann ein Betrieb eingegeben werden. Die Ergebnisse können
      anschließen für den Einzelbetrieb betrachtet und als PDF-Datei
      heruntergeladen werden.
    </p>
    <p>
      Die Zahl der via CSV-Dateien hochgeladenen Betriebsdatensätze ist nicht
      beschränkt. Werden bis zu drei Betriebsdatensätze hochgeladen, können die
      Ergebnisse für den Einzelbetrieb betrachtet und als PDF heruntergeladen
      werden. Zusätzlich stehen die PDF der Betriebe in einer ZIP-Datei zum
      gemeinsamen Download bereit. Werden mehr als drei Betriebsdatensätze
      hochgeladen, stehen die Ergebnisse ausschließlich als ZIP-Datei zur
      Verfügung.
    </p>
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon
            [icon]="faArrowLeft"
            class="ml-1 icon-vertical-align"
          ></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
